import WPStagingCommon from '../../wpstg.js';
import 'regenerator-runtime/runtime';
import WPStagingBackup from './wpstg-backup';
import WpstgBackupUploadUrl from './wpstg-backup-upload-url';
import * as dom from '../../modules/wpstg-dom-utils';

let WPStagingBackupUpload;

(function($) {
  window.addEventListener('backups-tab', function() {
    WPStagingBackupUpload.listen();
  });

  WPStagingBackupUpload = {
    isUploading: false,
    resumable: null,
    resumableFile: null,
    wpstgBackupUploadUrl: null,
    upload: {
      html: null,
      successMessage: null,
    },

    listen() {
      document.body.addEventListener('click', function(event) {
        if (event.target.id === 'wpstg-upload-backup') {
          WPStagingBackupUpload.uploadModal();
          WPStagingBackupUpload.wpstgBackupUploadUrl = new WpstgBackupUploadUrl();
        }
      });
    },

    /**
     * @see https://caniuse.com/fileapi
     */
    uploadNotSupported() {
      WPStagingCommon.showErrorModal('Your browser do not support the File API, needed for the uploads. Please try a different/updated browser, or upload the Backup using FTP to the folder <strong>wp-content/uploads/wp-staging/backups</strong>');
    },

    setModalStateStart() {
      WPStagingBackupUpload.isUploading = false;
      dom.qs('.wpstg--swal2-container #wpstg-upload-select').style.display = 'block';
      dom.qs('.wpstg--swal2-container #wpstg-upload-progress').style.display = 'none';
      dom.qs('.wpstg--swal2-container .wpstg--modal--backup--upload--content .wpstg-linear-loader').style.display = 'none';
    },

    setModalStateUploading() {
      WPStagingBackupUpload.isUploading = true;
      dom.qs('.wpstg--swal2-container #wpstg-upload-select').style.display = 'none';
      dom.qs('.wpstg--swal2-container #wpstg-upload-progress').style.display = 'block';
      dom.qs('.wpstg--swal2-container .wpstg--modal--backup--upload--content .wpstg-linear-loader').style.display = 'block';
      dom.qs('.wpstg--swal2-container .wpstg--modal--upload--process').style.display = 'flex';

      const _btnCancel = WPStagingCommon.getSwalContainer().getElementsByClassName('wpstg--swal2-cancel wpstg--btn--cancel')[0];
      const btnCancel = _btnCancel.cloneNode(true);
      _btnCancel.parentNode.replaceChild(btnCancel, _btnCancel);

      btnCancel.addEventListener('click', WPStagingBackupUpload.eventListenerConfirmCancelUpload);
    },

    eventListenerConfirmCancelUpload() {
      if (confirm('Do you want to abort the upload?')) {
        WPStagingBackupUpload.resumable.cancel();
        WPStagingCommon.closeSwalModal();
        WPStagingBackupUpload.deleteUnfinishedUploads();
      }
    },

    deleteUnfinishedUploads() {
      WPStagingCommon.ajax({
        action: 'wpstg--backups--uploads-delete-unfinished',
        accessToken: wpstg.accessToken,
        nonce: wpstg.nonce,
      },
      function(response) {
        // no-op
      },
      );
    },
    async uploadModal() {
      if (!WPStagingBackupUpload.upload.html || !WPStagingBackupUpload.upload.successMessage || document.getElementById('wpstg--modal--backup--upload')) {
        const uploadModal = document.getElementById('wpstg--modal--backup--upload');
        if (uploadModal) {
          const html = uploadModal.innerHTML;
          const successMessage = uploadModal.getAttribute('data-uploadSuccessMessage');
          WPStagingBackupUpload.upload.html = html || null;
          WPStagingBackupUpload.upload.successMessage = successMessage || null;
          uploadModal.parentNode.removeChild(uploadModal);
        }
      }

      await WPStagingCommon.getSwalModal(true, {
        confirmButton: 'wpstg--btn--confirm wpstg-blue-primary wpstg-button wpstg-link-btn wpstg-backup-download-button',
      }).fire({
        html: WPStagingBackupUpload.upload.html,
        showConfirmButton: true,
        showCloseButton: false,
        showLoaderOnConfirm: false,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: 'Upload',
        width: 650,
        allowEscapeKey: () => {
          return !WPStagingBackupUpload.isUploading;
        },
        allowOutsideClick: () => {
          return !WPStagingBackupUpload.isUploading;
        },
        onRender() {
          const uploadButton = WPStagingCommon.getSwalContainer().getElementsByClassName('wpstg-backup-download-button')[0];
          const btnUpload = uploadButton.cloneNode(true);
          uploadButton.parentNode.replaceChild(btnUpload, uploadButton);
          btnUpload.addEventListener('click', () => {
            WPStagingBackupUpload.wpstgBackupUploadUrl.uploadBackupFromUrl();
          });

          WPStagingBackupUpload.deleteUnfinishedUploads();
          WPStagingBackupUpload.setModalStateStart();

          WPStagingBackupUpload.resumable = new Resumable({
            target: wpstg.ajaxUrl,
            chunkSize: wpstg.maxUploadChunkSize,
            query: {
              accessToken: wpstg.accessToken,
              action: 'wpstg--backups--restore--file-upload',
              uniqueIdentifierSuffix: Math.floor(Math.random() * 99999999),
            },
            permanentErrors: [400, 401, 403, 404, 409, 415, 500, 501, 507, 413], // These will STOP the upload. Other errors will retry the chunk.
            fileType: ['wpstg', wpstg.backupDBExtension],
            simultaneousUploads: 1,
            prioritizeFirstAndLastChunk: false,
            testChunks: false,
            forceChunkSize: true,
          });
          WPStagingBackupUpload.resumable.resumableFile = null;

          if (!WPStagingBackupUpload.resumable.support) {
            WPStagingCommon.closeSwalModal();
            WPStagingBackupUpload.uploadNotSupported();

            return;
          }

          WPStagingBackupUpload.resumable.assignBrowse(dom.qs('.wpstg--swal2-container .resumable-browse'));
          WPStagingBackupUpload.resumable.assignDrop(dom.qs('.wpstg--swal2-container .resumable-drop'));

          WPStagingBackupUpload.resumable.on('fileAdded', WPStagingBackupUpload.handleFileAdded);
          WPStagingBackupUpload.resumable.on('fileSuccess', WPStagingBackupUpload.handleFileSuccess);
          WPStagingBackupUpload.resumable.on('error', WPStagingBackupUpload.handleError);
          WPStagingBackupUpload.resumable.on('progress', WPStagingBackupUpload.handleProgress);
        },
      });
    },

    handleFileAdded(file) {
      const uploadButton = WPStagingCommon.getSwalContainer().getElementsByClassName('wpstg-backup-download-button')[0];
      if (uploadButton) {
        uploadButton.style.display = 'none';
      }

      WPStagingBackupUpload.setModalStateUploading();

      WPStagingBackupUpload.resumable.resumableFile = file;
      WPStagingBackupUpload.resumable.upload();
    },

    handleFileSuccess(file, message) {
      WPStagingCommon.closeSwalModal();
      WPStagingCommon.showSuccessModal(WPStagingBackupUpload.upload.successMessage);
      dom.setLoadingPlaceholder().then(() => dom.loadingPlaceholder());
      WPStagingBackup.fetchListing();
    },

    handleProgress() {
      const percent = Math.floor(WPStagingBackupUpload.resumable.progress() * 100);

      dom.qs('.wpstg--swal2-container .wpstg--modal--upload--progress').style.width = percent + '%';
      dom.qs('.wpstg--swal2-container .wpstg--modal--upload--progress--title > span').textContent = percent + '%';
    },

    handleError(message, file) {
      try {
        const json = JSON.parse(message);

        if (json.hasOwnProperty('data') && json.data.hasOwnProperty('message')) {
          if (json.data.hasOwnProperty('isDiskFull') && json.data.isDiskFull) {
            WPStagingBackupUpload.resumable.cancel();
            WPStagingCommon.closeSwalModal();
            WPStagingCommon.showErrorModal(json.data.message);
            return;
          }

          if (json.data.hasOwnProperty('backupFailedValidation') && json.data.backupFailedValidation) {
            WPStagingBackupUpload.resumable.cancel();
            WPStagingCommon.closeSwalModal();
            WPStagingCommon.showErrorModal(json.data.message);
            return;
          }

          if (!json.success) {
            WPStagingBackupUpload.resumable.cancel();
            WPStagingCommon.closeSwalModal();
            WPStagingCommon.showErrorModal(json.data.message);
            return;
          }
        }
      } catch (e) {
        // not a JSON message, no-op
      }

      // Reduce chunk by 10%, with a minimum of 256kb reduction
      const reduceChunkBytes = Math.max(256 * 1024, WPStagingBackupUpload.resumable.opts.chunkSize * 0.1);

      WPStagingBackupUpload.resumable.opts.chunkSize = Math.ceil(WPStagingBackupUpload.resumable.opts.chunkSize - reduceChunkBytes);

      if (WPStagingBackupUpload.resumable.opts.chunkSize < 64 * 1024) {
        WPStagingCommon.closeSwalModal();
        WPStagingCommon.showErrorModal('We could not upload the backup file, please try uploading it directly using FTP to the folder wp-content/uploads/wp-staging/backups. Please also make sure you have enough free disk space on the server.');
      }

      WPStagingBackupUpload.deleteUnfinishedUploads();

      // console.log(WPStagingBackupUpload.resumable.opts.chunkSize);
      WPStagingBackupUpload.resumable.files[0].retry();
    },
  };
}(jQuery));

export default WPStagingBackupUpload;
